import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

import RetailerSelector from './RetailerSelector';

const iposConfigData = {
    retailerGln: '',
    username: '',
    password: '',
    passwordConfirm: ''
};

class CreateIposConfigModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = iposConfigData;

        this.cancel = this.cancel.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.submit = this.submit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    cancel() {
        this.setState(iposConfigData);
        this.props.onCancel();
    }

    setProperty(propertyName, propertyValue) {
        const property = {[propertyName]: propertyValue};
        this.setState(property);
    }

    submit() {
        this.props.onSubmit(this.state);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState(iposConfigData);
        }
    }

    isValid() {
        return this.state.retailerGln !== '' &&
            this.state.username !== '' &&
            this.state.password !== '' &&
            this.state.passwordConfirm !== '' &&
            (this.state.password === this.state.passwordConfirm);
    }

    render() {

        const disabled = !this.isValid();

        return (
            <Modal isOpen={this.props.visible} centered={true} className={this.props.className}>
                <ModalHeader>Neue IPOS-Konfiguration</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="cICModalRetailerGln">Händler</label>
                                    <RetailerSelector retailers={this.props.retailers} showPleaseSelectOpt={true}
                                                      value={this.state.retailerGln} width='350px'
                                                      onChange={(value) => this.setProperty('retailerGln', value)}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cICModalUsername">Benutzername</label>
                                    <input type="text" className="form-control" id="cICModalUsername"
                                           onChange={(event) => this.setProperty('username', event.target.value)}
                                           placeholder="Benutzername..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cICModalPassword">Passwort</label>
                                    <input type="password" className="form-control" id="cICModalPassword"
                                           onChange={(event) => this.setProperty('password', event.target.value)}
                                           placeholder="Passwort..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cICModalPasswordConfirm">Passwort bestätigen</label>
                                    <input type="password" className="form-control" id="cICModalPasswordConfirm"
                                           onChange={(event) => this.setProperty('passwordConfirm', event.target.value)}
                                           placeholder="Passwort..." required={true}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={disabled} color="primary" onClick={this.submit}>Konfiguration anlegen</Button>{' '}
                    <Button color="secondary" onClick={this.cancel}>Abbrechen</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateIposConfigModal;



// WEBPACK FOOTER //
// ./src/admin/retailer/CreateIposConfigModal.js